export const data = [
    {id: 1, discount: true, price: '200 000',  title: 'the best', description: 'Test Description'},
    {id: 2, discount: true, price: '200 000',  title: 'the best', description: 'Test Description'},
    {id: 3, discount: true, price: '200 000',  title: 'the best', description: 'Test Description'},
    {id: 14, discount: true, price: '200 000', title: 'the best', description: 'Test Description'},
    {id: 15, discount: true, price: '200 000', title: 'the best', description: 'Test Description'},
    {id: 16, discount: true, price: '200 000', title: 'the best', description: 'Test Description'},
    {id: 17, discount: true, price: '200 000', title: 'the best', description: 'Test Description'},
    {id: 18, discount: true, price: '200 000', title: 'the best', description: 'Test Description'},
]